import Typography, { ColorTypes, TypographyProps, TypographyTypes } from './typography';

export type { TypographyProps, TypographyTypes, ColorTypes };
export default Typography;
